<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header">Calculer un IMC</div>
        <div class="modal-body">
            <div class="modal-elements">
                <div class="top-modale">
                    <form class="formulaire" [formGroup]="formGroup" (ngSubmit)="submitSettings()" *ngIf="formGroup">
                        <div class="imc-checkboxes">
                            <frg-form-input label="Femme" id="femme" type="checkbox" [formGroup]="formGroup"
                                [control]="formGroup.get('isFemme')" [isCheckLabelAlign]="true">
                            </frg-form-input>
                            <frg-form-input label="Homme" id="homme" type="checkbox" [formGroup]="formGroup"
                                [control]="formGroup.get('isHomme')" [isCheckLabelAlign]="true">
                            </frg-form-input>
                        </div>
                        <div *ngIf="formGroup.errors?.genderRequired && formGroup.touched"
                            class="error-container group-error">
                            Veuillez sélectionner un genre.
                        </div>
                        <div class="imc-inputs">
                            <frg-form-input class="imc-input" id='taille' label="Taille en cm" type="text"
                                [formGroup]="formGroup" [control]="formGroup.get('taille')"></frg-form-input>
                            <frg-form-input class="imc-input" id='poids' label="Poids en Kg" type="text"
                                [formGroup]="formGroup" [control]="formGroup.get('poids')"></frg-form-input>
                        </div>
                        <div class="error-container group-error" [ngClass]="{'no-height': !isError}">
                            {{errorMessage}}
                        </div>
                        <div class="button-container">
                            <frg-button (click)="calculateImc()" [disabled]="isSubmitDisabled"
                                [ngClass]="{ 'no-action': !formGroup.valid }"
                                [backgroundColor]="'var(--primary)'">Calculer</frg-button>
                        </div>
                    </form>
                    <div class="imc-result-container">
                        <div *ngIf="isImcResult" class="imc-result">Valeur de l'IMC : {{imc}}</div>
                    </div>
                </div>
                <google-chart class="google-chart" [title]="chart.title" [type]="chart.type" [data]="chart.data"
                    [options]="chart.options">
                </google-chart>
            </div>
            <div class="buttons-wrapper">
                <frg-button (activated)="closeModal()" [backgroundColor]="'var(--darkest-primary)'">Fermer</frg-button>
                <frg-button [type]="'button'" (activated)="addMaquetteToCurrentConsultation()"
                    [disabled]="!isImcResult">Enregistrer dans la consultation</frg-button>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>